import React from "react";

import Dashboard from "views/admin/default";


import {
  MdAttachMoney,
  MdBarChart,
  MdContacts,
  MdHome,
  MdLock,
  MdPerson,
} from "react-icons/md";
import Deals from "components/leads";
import Contacts from "components/contacts";
import KPITable from "components/KPITable";

const routes = [
  {
    name: "Dashboard",
    layout: "/",
    path: "dashboard", 
    icon: <MdHome className="h-6 w-6" />,
    component: <Dashboard />,
  },
  {
    name: "Contacts",
    layout: "/",
    path: "contact",
    icon: <MdContacts className="h-6 w-6" />,
    component: <Contacts />,
  },
  {
    name: "Leads",
    layout: "/",
    path: "leads",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Deals />,
  },
  {
    name: "KPI",
    layout: "/",
    path: "kpi",
    icon: <MdLock className="h-6 w-6" />,
    component: <KPITable />,
  },
];
export default routes;
